import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClubRoom } from '../../models/clubs/club-room.model';

@Injectable({
    providedIn: 'root',
})
export class SelectedRoomsService {
    public selectedRoomsByClubIdSubject = new BehaviorSubject<{ [clubId: string]: ClubRoom[] }>({});
    public selectedRooms$ = this.selectedRoomsByClubIdSubject.asObservable();

    updateSelectedRooms(selectedRooms: { [clubId: string]: ClubRoom[] }) {
        this.selectedRoomsByClubIdSubject.next(selectedRooms);
    }

    isSelectedRoomsEmpty(): boolean {
        const selectedRooms = this.selectedRoomsByClubIdSubject.value;
        return Object.values(selectedRooms).every((rooms) => rooms.length === 0);
    }
    getSelectedRoomIds(): string[] {
        const selectedRooms = this.selectedRoomsByClubIdSubject.value;
        const roomIds: string[] = [];

        Object.values(selectedRooms).forEach((rooms) => {
            rooms.forEach((room) => {
                roomIds.push(room.id);
            });
        });

        return roomIds;
    }
}
